export default function Fact(){
    return(<>
    <section id="facts" className="facts">
      <div className="container">

        <div className="section-title">
          <h2>Facts</h2>
          <p>Throughout my journey, I have encountered a diverse range of individuals, each bringing unique perspectives and ideas. By embracing their input, I have gained invaluable knowledge and crafted tailored solutions that have empowered their businesses, fueling remarkable growth and success.</p>
        </div>

        <div className="row no-gutters">

          <div className="col-lg-6 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up">
            <div className="count-box">
              <i className="icofont-simple-smile"></i>
              <span data-toggle="counter-up">67</span>
              <p><strong>Happy Clients</strong> </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up" data-aos-delay="100">
            <div className="count-box">
              <i className="icofont-document-folder"></i>
              <span data-toggle="counter-up">121</span>
              <p><strong>Projects</strong> Graphics, web, digital marketing</p>
            </div>
          </div>
        </div>

      </div>
    </section>
    </>);
}